import { render, staticRenderFns } from "./CaseInfo.vue?vue&type=template&id=7b06134d"
import script from "./CaseInfo.vue?vue&type=script&lang=js"
export * from "./CaseInfo.vue?vue&type=script&lang=js"
import style0 from "./CaseInfo.vue?vue&type=style&index=0&id=7b06134d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports